<template>
  <div>
    <vxe-grid
      ref="table"
      size="mini"
      border="inner"
      resizable
      auto-resize
      highlight-hover-row
      :loading="loading"
      :data="tableData"
      :columns="columns"
      :height="tableHeight"
      :toolbar-config="{ slots: { buttons: 'toolbar_form' } }"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      row-id="inspectorCode"
      :radio-config="
        !multiple
          ? {
              trigger: 'row',
              highlight: highlight,
              strict: false,
              reserve: reserve,
            }
          : {}
      "
      :checkbox-config="
        multiple
          ? {
              trigger: 'row',
              highlight: highlight,
              reserve: reserve,
            }
          : {}
      "
      @radio-change="radioChange"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
    >
      <template #toolbar_form>
        <slot name="header"></slot>
      </template>
      <template #pager>
        <slot name="pager"></slot>
      </template>

      <template #userStatus="{ row }">
        <UserStatus :value="row.userStatus" :label="row.userStatusText" />
      </template>

      <template #inspectorRole="{ row }">
        <InspectorRole
          :value="row.inspectorRole"
          :label="row.inspectorRoleText"
        />
      </template>

      <template #displayCreate="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createTime }}</span>
      </template>

      <template #displayModify="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyTime }}</span>
      </template>
      <template #empty>
        <div class="text-center">
          <img src="/image/static/img/nodata.png" />
          <p class="m-0 mt-2">
            {{ $l('INDEX.table_label_empty') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
import tableColumns from './TableColumns'
import UserStatus from '@/views/factory/inspection/inspector/components/user-status'
import InspectorRole from '@/views/factory/inspection/inspector/components/inspector-role'

export default {
  components: {
    UserStatus, 
    InspectorRole,
  },
  props: {
    tableHeight: { type: Number, default: 800 },
    multiple: { type: Boolean, default: false },
    reserve: { type: Boolean, default: true },
    highlight: { type: Boolean, default: true },
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  computed: {
    columns() {
      return tableColumns(this)
    },
  },
  methods: {
    checkboxChange({ records, reserves }) {
      this.$emit('chooseChange', records.concat(reserves))
    },
    radioChange({ newValue }) {
      if (!newValue && this.reserve) {
        this.$refs.table.clearRadioReserve()
      }
      this.$emit('chooseChange', newValue)
    },
  },
}
</script>

<style lang="scss" scoped>
.tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>
